import api from '@edu-fe/api'

export default {
  name: 'present',
  fetchBookList: api.create('/activity/book/list'),
  fetchShareID: params => api.create('/activity/wx/share', { data: params })(),
  shareBook: shareId => api.create(`/activity/share/info?shareId=${shareId}`),
  getBook: shareId => api.create(`/activity/receive/book`, {
    method: 'POST',
    data: {
      shareId
    }
  })
}
